import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import KakaoAdfit1 from "../KakaoAdfit/KakaoAdfit1";
import KakaoAdfit2 from "../KakaoAdfit/KakaoAdfit2";
import KakaoAdfit3 from "../KakaoAdfit/KakaoAdfit3";
import KakaoAdfit4 from "../KakaoAdfit/KakaoAdfit4";
import { isMobile } from "../common/style";
import ResultPage from "./ResultPage";
import HairImg from "../common/image/game/머리.png";
import FaceImg from "../common/image/game/얼굴형.png";
import MouthImg from "../common/image/game/입.png";
import LEyeImg from "../common/image/game/left눈.png";
import LEyebrowImg from "../common/image/game/left눈썹.png";
import REyeImg from "../common/image/game/right눈.png";
import REyebrowImg from "../common/image/game/right눈썹.png";
import WindImg from "../common/image/game/바람.png";

const GamePage: React.FC = () => {
  const [wind, setWind] = useState(false);
  const [hairwind, setHairWind] = useState(false);
  const [time, setTime] = useState(10);
  const [result, setResult] = useState(true);

  useEffect(() => {
    const windInterval = setInterval(() => {
      if (wind === false) {
        WindHandler();
      }
    }, getRandomTime());

    const timeInterval = setInterval(() => {
      setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : prevTime));
    }, 1000);

    return () => {
      clearInterval(windInterval);
      clearInterval(timeInterval);
    };
  }, [wind]);

  const getRandomTime = () => {
    return Math.random() * 1000 + 500;
  };

  const WindHandler = () => {
    setWind(true);
    setHairWind(true);
    setTimeout(() => {
      setWind(false);
    }, 1000);
  };

  const StopBtn = () => {
    if (wind === true) {
      setHairWind(false);
    }
  };

  const hairAnimationEnd = () => {
    if (hairwind === true) {
      setResult(false);
      setTime(0);
    }
  };

  return (
    <Center>
      <h1>대머리를 조심해!</h1>
      <Container>
        {time === 0 ? (
          <ResultPage result={result} time={time} />
        ) : (
          <>
            <GameDiv>
              <FaceDiv stopani={hairwind ? 1 : 0}>
                <img src={FaceImg} alt="얼굴형" className="faceimg" />
                <img src={MouthImg} alt="입" className="mouthimg" />
                <img src={LEyeImg} alt="왼쪽눈" className="leyeimg" />
                <img src={LEyebrowImg} alt="왼쪽눈썹" className="leyebrowimg" />
                <img src={REyeImg} alt="오른쪽눈" className="reyeimg" />
                <img
                  src={REyebrowImg}
                  alt="오른쪽눈썹"
                  className="reyebrowimg"
                />
                <img
                  src={HairImg}
                  alt="머리"
                  className="hairimg"
                  onAnimationEnd={hairAnimationEnd}
                />
              </FaceDiv>
              {wind && (
                <WindDiv windani={wind ? 1 : 0}>
                  <img src={WindImg} alt="바람" className="wind1" />
                  <img src={WindImg} alt="바람" className="wind2" />
                  <img src={WindImg} alt="바람" className="wind3" />
                </WindDiv>
              )}
            </GameDiv>
            <TimeBtnDiv>
              <h2>남은 시간 : {time}초</h2>
              <button onClick={StopBtn}>머리 잡기</button>
            </TimeBtnDiv>
          </>
        )}
      </Container>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default GamePage;

const windAnimation = keyframes`
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(20px,20px);
  }
`;

const HairAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-300%);
  }
`;

const LEyeBrowAnimation = keyframes`
  0% {
    transform: translate(0);
  }
  100% {
    transform: rotate(-60deg) translate(30px, -10px);
  }
`;

const REyeBrowAnimation = keyframes`
  0% {
    transform: translate(0);
  }
  100% {
    transform: rotate(-20deg) translate(17px, -63px);
  }
`;

const LEyeAnimation = keyframes`
  0% {
    transform: translate(0);
  }
  100% {
    transform: translate(-2px, -30px);
  }
`;

const REyeAnimation = keyframes`
  0% {
    transform: translate(0);
  }
  100% {
    transform: translate(2px, -70px);
  }
`;

const MouthAnimation = keyframes`
  0% {
    transform: translate(0);
  }
  100% {
    transform: rotate(-110deg) translate(8px, 63px);
  }
`;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #edc1c1;

    margin-top: 63px;
    margin-bottom: 50px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 20px;
    }
  }
`;

const Container = styled.div`
  height: 500px;

  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${isMobile} {
    height: 380px;
  }
`;

const GameDiv = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

const WindDiv = styled.div<{ windani: number }>`
  position: relative;

  img {
    position: absolute;
    top: 0;
    left: 0;
    animation: ${({ windani }) =>
      windani
        ? css`
            ${windAnimation} 0.5s linear infinite
          `
        : "none"};

    ${isMobile} {
      width: 80px;
    }
  }

  .wind1 {
    margin-left: -470px;

    ${isMobile} {
      margin-left: -230px;
    }
  }

  .wind2 {
    margin-top: 60px;
    margin-left: 10px;

    ${isMobile} {
      margin-top: 60px;
      margin-left: -40px;
    }
  }

  .wind3 {
    margin-top: 330px;
    margin-left: -350px;

    ${isMobile} {
      margin-top: 170px;
      margin-left: -180px;
    }
  }
`;

const FaceDiv = styled.div<{ stopani: number }>`
  position: relative;
  width: 294px;
  margin-top: 60px;

  ${isMobile} {
    width: 180px;
    margin-top: 30px;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
  }

  .leyebrowimg {
    margin-top: 163px;
    left: 12%;
    animation: ${({ stopani }) =>
      stopani
        ? css`
            ${LEyeBrowAnimation} 0.4s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      margin-top: 98px;
      left: 13%;
      width: 38.62px;
    }
  }

  .reyebrowimg {
    margin-top: 163px;
    left: 65%;
    animation: ${({ stopani }) =>
      stopani
        ? css`
            ${REyeBrowAnimation} 0.4s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      margin-top: 98px;
      width: 38.62px;
    }
  }

  .leyeimg {
    margin-top: 170px;
    left: 23%;
    animation: ${({ stopani }) =>
      stopani
        ? css`
            ${LEyeAnimation} 0.4s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      margin-top: 103px;
      width: 16px;
    }
  }

  .reyeimg {
    margin-top: 170px;
    left: 67%;
    animation: ${({ stopani }) =>
      stopani
        ? css`
            ${REyeAnimation} 0.4s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      margin-top: 103px;
      width: 16px;
    }
  }

  .mouthimg {
    margin-top: 220px;
    left: 37%;
    animation: ${({ stopani }) =>
      stopani
        ? css`
            ${MouthAnimation} 0.4s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      margin-top: 132px;
      width: 44.69px;
    }
  }

  .faceimg {
    ${isMobile} {
      width: 180px;
    }
  }

  .hairimg {
    animation: ${({ stopani }) =>
      stopani
        ? css`
            ${HairAnimation} 0.4s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      width: 180px;
    }
  }
`;

const TimeBtnDiv = styled.div`
  margin-top: 270px;
  margin-left: 410px;

  ${isMobile} {
    margin-top: 210px;
    margin-left: 0;
  }

  h2 {
    color: #d48f8f;
    font-family: GmarketSansBold;
    font-size: 23px;
    font-weight: 700;

    ${isMobile} {
      font-size: 20px;
    }
  }

  button {
    margin-top: 8px;
    width: 170px;
    height: 80px;
    border-radius: 100px;
    border: 3px solid #edb4b4;
    background: #fff;

    color: #d48f8f;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 25px;
    font-weight: 700;

    cursor: pointer;

    &:hover {
      background: #ffeaea;
    }

    ${isMobile} {
      margin-top: 8px;
      width: 170px;
      height: 65px;
      border: 2px solid #edb4b4;
      font-size: 22px;
    }
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-top: 100px;
  margin-right: 920px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-top: 100px;
  margin-left: 920px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
`;
